var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Feature, BatteryTypeEnum, CompaniesClient, GetSystemCommunicationsViewPaginatedQuery, PaginatedEnumerableOfSystemQuery, SitesClient, SortDescription, SortDirection, SystemCommunicationsClient, SystemsClient } from "@/app/api/battery-portal-api";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { Component, Vue, Watch } from "vue-facing-decorator";
import QueryStringHelper from "@/app/utils/querystring-helper";
import { DataGridStateHelper } from "@/app/utils/data-grid-state-helper";
import RouteNames from "@/app/router/routes";
import { LoginState } from "@/app/store/modules/login.state";
import { State } from "vuex-facing-decorator";
import moment from 'moment';
const systemCommunicationsClient = new SystemCommunicationsClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const systemsClient = new SystemsClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
let SystemCommunicationsVue = class SystemCommunicationsVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.sorter = new Sorter(new SortDescription({
            fieldName: "SystemName",
            direction: SortDirection.Ascending
        }));
        this.query = new GetSystemCommunicationsViewPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            keywords: "",
            systemId: null,
            companyId: null,
            siteId: null
        });
        this.data = new PaginatedEnumerableOfSystemQuery();
        this.columns = [
            { visible: true, fieldName: "system", title: "System" },
            { visible: true, fieldName: "site", title: "Site" },
            { visible: true, fieldName: "latestData", title: "Latest Data" },
            { visible: true, fieldName: "lastComms", title: "Last Comms" },
            { visible: true, fieldName: "lastCommsSourceId", title: "Last Comms Source" },
            { visible: true, fieldName: "oldestData", title: "Oldest Data" },
            { visible: true, fieldName: "monitor", title: "Monitor" },
            { visible: true, fieldName: "modem", title: "Modem" },
            { visible: true, fieldName: "quality", title: "Quality" },
            { visible: true, fieldName: "signal", title: "Signal" },
        ];
        this.companies = [];
        this.sites = [];
        this.systems = [];
    }
    // methods
    created() {
        this.loadDataGridState();
        this.getLookups();
    }
    ;
    mounted() {
        this.search();
    }
    ;
    onCompanyIdChanged() {
        this.siteId = this.filteredSites[0];
        this.systemId = this.filteredSystems[0];
        this.search();
    }
    onSiteIdChanged() {
        this.systemId = this.filteredSystems[0];
        this.search();
    }
    // get
    search() {
        if (this.working)
            return;
        this.working = true;
        systemCommunicationsClient
            .search(this.query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
            let params = [
                { value: this.query.keywords, parameterName: "keywords" },
                { value: this.query.companyId, parameterName: "companyId" },
                { value: this.query.siteId, parameterName: "siteId" },
                { value: this.query.systemId, parameterName: "systemId" }
            ];
            queryStringHelper.updateQueryStrings(params);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    getLookups() {
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `Any company` }].concat(companies);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            }),
            systemsClient
                .getSystems(false, Feature.Comms)
                .then(response => {
                if (!response)
                    return;
                this.systems = response;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
        ];
        Promise.all(promises).then(() => {
            this.working = true;
            if (queryStringHelper.hasParameter("keywords")) {
                queryStringHelper.setFromQueryString("keywords", null, (value) => {
                    this.query.keywords = value;
                    return this.query.keywords;
                });
            }
            if (queryStringHelper.hasParameter("companyId")) {
                queryStringHelper.setFromQueryString("companyId", null, (value) => {
                    this.query.companyId = value && parseInt(value) ? parseInt(value) : null;
                    return this.query.companyId;
                });
            }
            if (queryStringHelper.hasParameter("siteId")) {
                queryStringHelper.setFromQueryString("siteId", null, (value) => {
                    this.query.siteId = value && parseInt(value) ? parseInt(value) : null;
                    return this.query.siteId;
                });
            }
            if (queryStringHelper.hasParameter("systemId")) {
                queryStringHelper.setFromQueryString("systemId", null, (value) => {
                    this.query.systemId = value && parseInt(value) ? parseInt(value) : null;
                    return this.query.systemId;
                });
            }
            this.working = false;
            this.search();
        });
    }
    ;
    onDataGridStateChanged() {
        DataGridStateHelper.storeDataGridState("comms-grid", this.columns, this.sorter);
    }
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        if (!this.working) {
            this.onDataGridStateChanged();
            this.search();
        }
    }
    ;
    goToSnapshot(systemId) {
        // Create a unique key and send as parameter to reload the last snapshot case the page is cached.
        var uniqueKey = Math.floor(new Date().getTime() / 1000).toString();
        this.$router.push({ name: RouteNames.SnapshotForSystem, params: { systemId: systemId.toString(), uniqueKey: uniqueKey } });
    }
    ;
    get filteredSites() {
        var filteredSites = this.sites.filter(site => this.query.companyId == null || this.query.companyId == site.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        return [{ value: null, text: `Any site` }].concat(sites);
    }
    get filteredSystems() {
        let systems = (this.systems || [])
            .filter(system => { var _a, _b; return (((_a = this.companyId) === null || _a === void 0 ? void 0 : _a.value) == null || this.companyId.value == system.companyId) && (((_b = this.siteId) === null || _b === void 0 ? void 0 : _b.value) == null || this.siteId.value == system.siteId); })
            .map((system) => {
            return {
                value: system.systemId,
                text: system.systemName
            };
        });
        return [{ value: null, text: `Any system` }].concat(systems);
    }
    get systemId() {
        return this.filteredSystems.filter(item => {
            return item.value == this.query.systemId;
        })[0] || null;
    }
    ;
    set systemId(item) {
        if (!item)
            return;
        this.query.systemId = item.value;
    }
    ;
    get companyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set companyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get siteId() {
        return this.filteredSites.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set siteId(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    closeColumnSettingsMenu() {
        let dropdown = this.$refs.columnSettingsDropdown;
        dropdown.close(true);
    }
    ;
    get numberOfVisibleColumns() {
        return this.columns.filter(column => column.visible).length;
    }
    ;
    isVisible(name) {
        let column = this.columns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    ;
    loadDataGridState() {
        this.working = true;
        try {
            DataGridStateHelper.loadDataGridState("comms-grid", this.columns, this.sorter);
        }
        finally {
            this.working = false;
        }
    }
    getDateTimeFormatted(date) {
        return moment(date).format("DD MMM YYYY, HH:mm");
    }
    getBatteryType(batteryTypeId) {
        switch (batteryTypeId) {
            case BatteryTypeEnum.LeadAcid:
                return "Pb";
            case BatteryTypeEnum.Lithium:
                return "Li";
        }
        return "";
    }
    getLastCommsSource(lastCommsSourceId) {
        switch (lastCommsSourceId) {
            case null: return "Unknown";
            case 1: return "LAN";
            case 2: return "Cellular";
            case 3: return "SMTP Link";
            case 4: return "SMTP Controller";
            case 5: return "UDP";
            case 6: return "Cellwatch";
            case 7: return "SMTP Cellwatch";
        }
    }
    get isPowerShield() {
        return this.loginState.isPowerShield;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], SystemCommunicationsVue.prototype, "loginState", void 0);
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemCommunicationsVue.prototype, "onCompanyIdChanged", null);
__decorate([
    Watch("query.siteId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemCommunicationsVue.prototype, "onSiteIdChanged", null);
__decorate([
    Watch("query.systemId"),
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemCommunicationsVue.prototype, "search", null);
__decorate([
    Watch("numberOfVisibleColumns"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemCommunicationsVue.prototype, "onDataGridStateChanged", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemCommunicationsVue.prototype, "onSortChanged", null);
SystemCommunicationsVue = __decorate([
    Component({
        name: "SystemCommunicationsVue"
    })
], SystemCommunicationsVue);
export default SystemCommunicationsVue;
